import { ReactNode } from "react";
import { Control, FieldError, FieldPath, FieldValues, Merge } from "react-hook-form";

import DateTime from "@components/fields/DateTime";
import Input from "@components/fields/Input";
import { isMobileWeb, isNativeApp } from "@utils/platformUtils";

type Props<FormData extends FieldValues> = {
  autofocus?: boolean;
  control: Control<FormData>;
  disabled?: boolean;
  error: Merge<FieldError, (FieldError | undefined)[]> | undefined;
  futureOnly?: boolean;
  inputStyles?: boolean;
  label?: string | ReactNode;
  name: FieldPath<FormData>;
  pastOnly?: boolean;
  required?: boolean;
  skipSpacing?: boolean;
  spellcheck?: boolean;
};

const DateInput = <FormData extends FieldValues>({
  autofocus = false,
  control,
  disabled = false,
  error,
  futureOnly = false,
  inputStyles = false,
  label,
  name,
  pastOnly = false,
  required,
  skipSpacing = false,
  spellcheck = false
}: Props<FormData>) => {
  if (isNativeApp() || isMobileWeb()) {
    return (
      <DateTime
        control={control}
        dateOnly
        disabled={disabled}
        error={error}
        label={label}
        max={pastOnly ? new Date().toISOString().split("T")[0] : undefined}
        min={futureOnly ? new Date().toISOString().split("T")[0] : undefined}
        name={name}
        preferWheel
        presentation="date"
        required={required}
        spellCheck={spellcheck}
      />
    );
  } else {
    return (
      <Input
        autofocus={autofocus}
        control={control}
        disabled={disabled}
        error={error}
        inputStyles={inputStyles}
        label={label}
        max={pastOnly ? new Date().toISOString().split("T")[0] : undefined}
        min={futureOnly ? new Date().toISOString().split("T")[0] : undefined}
        name={name}
        noSpacing={skipSpacing}
        required={required}
        spellcheck={spellcheck}
        type="date"
      />
    );
  }
};

export default DateInput;
